import { OneDriveApiError } from '@/lib/api/onedrive.js';

export interface OneDriveErrorPresentation {
  message: string;
  remediation: string;
  canRetry: boolean;
  operationCompleted: boolean | null;
}

export function oneDriveErrorPresentation(
  error: unknown,
): OneDriveErrorPresentation {
  if (!(error instanceof OneDriveApiError)) {
    return {
      message: 'OneDrive is unavailable.',
      remediation: 'Try again later.',
      canRetry: false,
      operationCompleted: null,
    };
  }
  return {
    message: error.message,
    remediation: error.remediation,
    canRetry: error.retryable && error.operationCompleted === false,
    operationCompleted: error.operationCompleted,
  };
}
